import { Button } from '@/components/Button/Button'
import modalService from '@/services/modal.service'
import React, { useState } from 'react'
// eslint-disable-next-line
import { ReactComponent as CrossIcon } from '@/assets/icons/editor/cross-times-chip.svg'
import { InputMask } from '@/components/InputMask/InputMask'

import './PurchaseAnotherDomainModal.scoped.sass'
import { SimpleBanner } from '@/components/Banners/SimpleBanner'
import sessionService from '@/app-domains/user/session/session.service'
import isValidDomain from 'is-valid-domain'
import ToastService from '@/components/Toast/Toast.service'

export function PurchaseAnotherDomainModal () {
  const [domain, setDomain] = useState()
  const validDomain = isValidDomain(domain)

  const userRequestedPurchasingAnotherDomain = async () => {
    await sessionService.requestPurchaseAnotherDomain(domain)
    modalService.close()
  }

  function validateDomain () {
    userRequestedPurchasingAnotherDomain()
    modalService.close()
  }

  return (<div className='modal'>
    <div className='modal-header'>
      <div>
        <p className='main-phrase'>Add another domain to your Boxes account</p>
        <p className='main-subphrase'>Enjoy all the Boxes features using multiple domains!</p>
      </div>
      <div className='close-icon' onClick={() => modalService.close()}><CrossIcon/></div>
    </div>
    <div className='modal-content'>
      <p>
        In order to proceed, we need you to tell us the following information:
      </p>
      <div className='info-div'>
        <div className='field-div'>
          <InputMask placeholder='Domain...' label="What domain do you want to purchase?" value={domain} onInput={setDomain} />
        </div>
      </div>
      <SimpleBanner type='info'>
        After you click "Request Purchase", our team will receive a notification and will contact you as soon as possible.
      </SimpleBanner>
    </div>
    <div className='cancel-actions'>
      <div className='close-cancel'>
        <Button content="Request purchase" type='primary' click={() => {
          validDomain === true
            ? validateDomain()
            : ToastService.show({
              type: 'error',
              title: 'We are sorry :(',
              message: `Your new domain '${domain}' is not valid.`,
            })
        }}/>
      </div>
    </div>
  </div>)
}
